import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  id: "photos-title-banner-component",
  class: "text-white"
}
const _hoisted_2 = {
  id: "photos-content-row",
  class: "row text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhotoListItem = _resolveComponent("PhotoListItem")!
  const _component_PhotoListHomeItemEmpty = _resolveComponent("PhotoListHomeItemEmpty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.photos, (photo, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "col-12 col-sm-4 p-1"
        }, [
          photo
            ? (_openBlock(), _createBlock(_component_PhotoListItem, {
                key: 0,
                class: "bg-dark photo-home-list-item overflow-hidden",
                item: photo,
                isHome: true,
                onClicked: ($event: any) => (photo.title !== '' ? _ctx.clickedItem(photo) : '')
              }, null, 8, ["item", "onClicked"]))
            : (_openBlock(), _createBlock(_component_PhotoListHomeItemEmpty, {
                key: 1,
                class: "photo-home-list-item"
              }))
        ]))
      }), 128))
    ])
  ]))
}